import React from 'react';

import Link from '@swf/components/Link/Link';

import styles from './CasinoHeaderTitle.scss';

interface Props {
  title: string | undefined;
  moreLink: string | undefined;
}

const CasinoHeaderTitle: React.FC<Props> = ({ moreLink, title, ...props }) =>
  moreLink ? (
    <Link {...props} href={moreLink} className={styles.title}>
      {title}
    </Link>
  ) : title ? (
    <h1 className={styles.title}>{title}</h1>
  ) : null;

export default CasinoHeaderTitle;
